"use client"

import {useMemo} from "react"
import {useLocale, useTranslations} from "next-intl"
import {formatYmdDateRangeLabel, formatDateRangeLabelInTimezone, formatRoiDisplay, formatExpenseDisplay, formatCostPerOrderDisplay} from "@/components/shopify/attribution-dashboard/format-display"

export function useAttributionFormatters() {
  const t = useTranslations("AttributionFormats")
  const locale = useLocale()
  return useMemo(() => ({
    formatYmdDateRangeLabel: (from: string, to: string) => formatYmdDateRangeLabel(from, to, locale),
    formatDateRangeLabelInTimezone: (from: Date, to: Date, timeZone: string) => formatDateRangeLabelInTimezone(from, to, timeZone, locale),
    formatRoiDisplay: (roi: number | undefined, expense: number | undefined) => formatRoiDisplay(roi, expense, locale),
    formatExpenseDisplay: (expense: number | undefined) => formatExpenseDisplay(expense, t, locale),
    formatCostPerOrderDisplay: (cost: number | undefined, expense: number | undefined) => formatCostPerOrderDisplay(cost, expense, locale),
  }), [t, locale])
}
